<template>
  <div id="app">
    <!-- <nav-component></nav-component> -->
    <transition name='fade'>
      <router-view/>
    </transition>
    <!-- <footer-component></footer-component> -->
  </div>
</template>

<script>
import NavComponent from '@/components/header.vue'
import FooterComponent from '@/components/footer.vue'
export default {
  components: {
    NavComponent,
    FooterComponent
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'MicrosoftJhengHei', '', '微软雅黑', 'Microsoft Yahei', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
.fade-enter, .fade-leave-active {
  transition: opacity .5s ease;

}
</style>
